<ng-container>
  <div class="uw-dialog-header">
    <h1 class="uw-dialog-heading">{{ "common.scheduled_email_delete_confirmation" | translate }}</h1>

    <button [attr.aria-label]="'aria.close' | translate" cdkFocusInitial mat-icon-button mat-dialog-close>
      <mat-icon>
        close
      </mat-icon>
    </button>
  </div>

  <div class="uw-dialog-content">
    <h2>{{ "common.are_you_certain_you_want_to_delete_this_schedule?" | translate }}</h2>
  </div>

  <div class="uw-dialog-footer" >
    <div class="uw-actions">     

      <button class="uw-default-button" (click)="confirm()">
        {{ "common.delete" | translate }}
      </button> 
      
      <button class="uw-stroked-button" mat-dialog-close>
        {{ "common.cancel" | translate }}
      </button>

    </div>
  </div>

</ng-container>